var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVideo = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.64 12.061 3.231 2.275a.625.625 0 0 0 .879-.572v-7.53a.625.625 0 0 0-.879-.57l-3.23 2.274a.625.625 0 0 0-.266.51v3.102a.624.624 0 0 0 .265.511Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.469 14.998H3.28a2.037 2.037 0 0 1-2.031-2.03V7.03a2.037 2.037 0 0 1 2.031-2.031h7.207A2.019 2.019 0 0 1 12.5 7.01v5.956a2.037 2.037 0 0 1-2.031 2.031Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
})));
export { SvgVideo as ReactComponent };